import { useState, ReactNode } from 'react'
import styled from 'styled-components'
import { ExpandableLabel, Flex, FlexProps, Text } from '@library/uikit'
import { useTranslation } from '@library/localization'

interface FoldableTextProps extends Omit<FlexProps, 'title'> {
  title?: ReactNode
}

const Wrapper = styled(Flex)`
  cursor: pointer;
`

const TitleText = styled(Text)`
  font-weight: bold;
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 18px;
  }
`

const StyledExpandableLabelWrapper = styled(Flex)`
  button {
    font-size: 16px;
    color: white;
    align-items: center;
    justify-content: flex-start;
    opacity: 0.6;
  }

  svg {
    fill: white;
    opacity: 0.6;
  }
`

const StyledChildrenFlex = styled(Flex)<{ isExpanded?: boolean }>`
  overflow: hidden;
  height: ${({ isExpanded }) => (isExpanded ? '100%' : '0px')};
  padding-bottom: ${({ isExpanded }) => (isExpanded ? '16px' : '0px')};
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
`

const FoldableText: React.FC<FoldableTextProps> = ({ title, children, ...props }) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Flex {...props} flexDirection="column">
      <Wrapper justifyContent="space-between" alignItems="center" pb="16px" onClick={() => setIsExpanded((s) => !s)}>
        <TitleText>{title}</TitleText>
        <StyledExpandableLabelWrapper>
          <ExpandableLabel expanded={isExpanded}>{isExpanded ? t('Hide') : t('Details')}</ExpandableLabel>
        </StyledExpandableLabelWrapper>
      </Wrapper>
      <StyledChildrenFlex isExpanded={isExpanded} flexDirection="column">
        {children}
      </StyledChildrenFlex>
    </Flex>
  )
}

export default FoldableText
